<template>
  <div class="projects">
    <div class="head-box">
      <h4>
        {{
          orderState == 'my'
            ? '我创建的'
            : orderState == 'todo'
            ? '待办'
            : orderState == 'done'
            ? '已办'
            : orderState == 'archived'
            ? '已归档'
            : '全部'
        }}项目
      </h4>
      <div class="c-flex c-flex-item">
        <el-input
          placeholder="请输入标题/编号/客户姓名/手机/详细地址"
          v-model="searchValue"
          style="width: 330px"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button
          v-if="!orderState || orderState == 'my'"
          type="primary"
          @click="doNew"
          class="c-m-l-10"
        >
          新建项目
        </el-button>
        <el-button
          v-if="!orderState && osg.has('Projects,export')"
          type="primary"
          class="c-m-l-10"
          @click="
            osg.doExport(
              {
                'in:state|array-integer#and': '0,1',
                'fpi-regex:name|string#or': searchValue,
                'fpi-regex:title|string#or': searchValue,
                'fpi-regex:phone|string#or': searchValue,
                'fpi-regex:orderNum|string#or': searchValue,
                'fpi-regex:address|string#or': searchValue,
                beanName: 'project',
                title: '项目列表'
              },
              { dynamic: true }
            )
          "
        >
          数据导出
        </el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-blue c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table
          height="calc(100% - 50px)"
          :data="fpi.data"
          style="width: 100%"
          v-show="refresh"
          ref="table"
          highlight-current-row
          border
          @header-dragend="osg.colWidthChange"
        >
          <c-table :fields="extFields" :options="options" dataPath="data"></c-table>
          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <template v-if="orderState != 'archived'">
                    <el-dropdown-item
                      v-if="osg.has('Projects,edit')"
                      @click.native="doEdit(scope.row.data)"
                    >
                      编辑
                    </el-dropdown-item>
                    <el-dropdown-item
                      v-if="osg.has('Projects,urged')"
                      @click.native="readyAlert(scope.row.data)"
                    >
                      催办
                    </el-dropdown-item>
                    <el-dropdown-item
                      v-if="osg.has('Projects,able') && scope.row.data.state == 0"
                      @click.native="doEnable(scope.row.data && scope.row.data._id)"
                    >
                      启用
                    </el-dropdown-item>
                    <el-dropdown-item
                      v-if="osg.has('Projects,able') && scope.row.data.state == 1"
                      @click.native="doDisable(scope.row.data && scope.row.data._id)"
                    >
                      禁用
                    </el-dropdown-item>
                    <el-dropdown-item
                      v-if="osg.has('Projects,remove') && scope.row.data.state == 1"
                      @click.native="doRemove(scope.row.data && scope.row.data)"
                    >
                      删除
                    </el-dropdown-item>
                    <el-dropdown-item
                      v-if="osg.has('Projects,archive')"
                      @click.native.prevent="doArchive(scope.row.data, '归档')"
                    >
                      归档
                    </el-dropdown-item>
                    <el-dropdown-item
                      v-if="
                        orderState == 'todo' &&
                          scope.row.nodeDef &&
                          scope.row.nodeDef.nodeType == 'allot'
                      "
                      @click.native="openSR(scope.row)"
                      divided
                    >
                      分单
                    </el-dropdown-item>
                    <el-dropdown-item
                      v-if="
                        orderState == 'todo' &&
                          scope.row.nodeDef &&
                          scope.row.nodeDef.nodeType == 'dispatch'
                      "
                      @click.native="openSR(scope.row)"
                      divided
                    >
                      派单
                    </el-dropdown-item>
                    <template
                      v-if="osg.has('Projects,reassign') && !orderState && btnShow(scope.row.data)"
                    >
                      <template
                        v-for="(item, i) of scope.row.data && scope.row.data.workflowNodeList"
                      >
                        <el-dropdown-item
                          :key="i"
                          v-if="
                            i != 0 && available(item, scope.row.data && scope.row.data.createUser)
                          "
                          @click.native="openSR(scope.row.data, item)"
                          divided
                        >
                          重新{{ item.nodeDef.name }}
                        </el-dropdown-item>
                      </template>
                    </template>
                  </template>
                  <template v-else>
                    <el-dropdown-item
                      v-if="osg.has('Projects?orderState=archived,recover')"
                      @click.native.prevent="doArchive(scope.row.data, '恢复')"
                    >
                      恢复
                    </el-dropdown-item>
                  </template>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      title="项目"
      :visible.sync="openDetail"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <c-form
        :formData="formData"
        :fields="extFields"
        :options="options"
        ref="form"
        :upload="upload"
        labelWidth="120px"
        :area="area"
        @changeForm="osg.changeForm"
      >
        <template slot="address">
          <el-input
            v-model="formData.address"
            suffix-icon="el-icon-map-location"
            @blur="getGeocode"
          ></el-input>
        </template>
      </c-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="服务资源"
      :visible.sync="SR.show"
      custom-class="c-dialog"
      @close="cancelSR"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="c-flex c-flex-end">
        <el-select
          v-if="SR.nodeType == 'allot'"
          v-model="SR.ids"
          placeholder="搜索服务区域"
          class="screen"
          clearable
          filterable
          remote
          :remote-method="getServiceTerritory"
          @clear="
            SR.fpi.page = 1;
            getServiceTerritory();
            getSR();
          "
          @change="
            SR.fpi.page = 1;
            SR.selectId = '';
            SR.selectRow = {};
            getSR();
          "
        >
          <el-option
            v-for="(item, i) in options.serviceTerritory"
            :key="i"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-select
          v-model="SR.resourceType"
          multiple
          placeholder="筛选资源类型"
          class="screen"
          clearable
          @clear="
            SR.fpi.page = 1;
            getSR();
          "
          @change="
            SR.fpi.page = 1;
            getSR();
          "
        >
          <template v-for="item in options.resourceType">
            <el-option
              :key="item.value"
              :label="item.label"
              :value="item.value"
              v-if="
                !SR.nodeType ||
                  (SR.nodeType == 'allot' &&
                    (item.value == 'partner' || item.value == 'serviceCrew')) ||
                  (SR.nodeType == 'dispatch' &&
                    item.value != 'partner' &&
                    item.value != 'serviceCrew')
              "
            ></el-option>
          </template>
        </el-select>
        <el-select
          v-model="SR.resourceRoles"
          multiple
          placeholder="筛选资源角色"
          class="screen"
          clearable
          @clear="
            SR.fpi.page = 1;
            getSR();
          "
          @change="
            SR.fpi.page = 1;
            getSR();
          "
        >
          <template v-for="item in options.resourceRoles">
            <el-option :key="item.value" :label="item.label" :value="item.value"></el-option>
          </template>
        </el-select>
        <el-input
          placeholder="请输入资源名称"
          v-model="SR.searchValue"
          class="search-input c-fr"
          clearable
          @clear="
            SR.fpi.page = 1;
            getSR();
          "
          @keyup.enter.native="
            SR.fpi.page = 1;
            getSR();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              SR.fpi.page = 1;
              getSR();
            "
          ></el-button>
        </el-input>
      </div>
      <el-table
        v-loading="SR.loading"
        :data="SR.fpi.data"
        height="100%"
        style="width: 100%; min-height: 440px"
        fit
        header-row-class-name="c-black-dark"
        highlight-current-row
        @current-change="selectSR"
      >
        <el-table-column label="选择" width="50px;">
          <template slot-scope="scope">
            <el-radio v-model="SR.selectId" :label="scope.row._id">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="资源名称"></el-table-column>
        <el-table-column
          prop="resourceType"
          label="资源类型"
          :formatter="formatSRType"
        ></el-table-column>
        <el-table-column label="资源">
          <template slot-scope="scope">
            <template
              v-if="scope.row.resourceType == 'partner' || scope.row.resourceType == 'serviceCrew'"
            >
              {{ formatOrg(scope.row.serviceCrewId) }}
            </template>
            <template v-else>
              {{ formatUser(scope.row.relatedRecordId) }}
            </template>
          </template>
        </el-table-column>
        <el-table-column
          prop="_id"
          label="服务区域"
          :formatter="formatST"
          v-if="SR.nodeType == 'allot'"
        ></el-table-column>
        <el-table-column prop="lastKnownLocation" label="最新位置"></el-table-column>
      </el-table>
      <div slot="footer">
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="SR.fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="SR.fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="SR.fpi.total"
        ></el-pagination>
        <div class="c-flex">
          <el-button type="primary" @click="saveSR">确 定</el-button>
          <el-button @click="cancelSR">取 消</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="催办"
      :visible.sync="workflowAlert"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      custom-class="c-dialog"
    >
      <el-form
        :model="workflowAlertData"
        :rules="rules"
        ref="workflowAlertData"
        label-width="100px"
        label-position="left"
      >
        <el-form-item label="催办类型" prop="type">
          <el-select v-model="workflowAlertData.type1Type" placeholder="请选择类型">
            <el-option
              v-for="item in options.workflowAlert"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="被催办人" prop="handlerIds">
          <el-select
            multiple
            v-model="workflowAlertData.handlerIds"
            placeholder="请选择待办人"
            clearable
            filterable
          >
            <el-option
              v-for="item in alertUser"
              :key="item._id"
              :label="item.name"
              :value="item._id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="催办备注" prop="memo">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入给处理人的备注信息"
            v-model="workflowAlertData.memo"
          ></el-input>
        </el-form-item>
      </el-form>
      <el-table :data="alertTableData" style="width: 100%">
        <el-table-column
          prop="type1Type"
          label="催办类型"
          min-width="80"
          :formatter="formatType1Type"
        ></el-table-column>
        <el-table-column prop="createTime" label="发起时间" min-width="100"></el-table-column>
        <el-table-column prop="workflowNodeName" label="催办节点" min-width="80"></el-table-column>
        <el-table-column prop="handleUserName" label="处理人" min-width="100"></el-table-column>
        <el-table-column
          prop="state"
          label="状态"
          min-width="80"
          :formatter="formatAltertState"
        ></el-table-column>
        <el-table-column prop="memo" label="催办备注" min-width="180"></el-table-column>
        <el-table-column fixed="right" min-width="90" label="操作">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.callId"
              @click.native.prevent="viewCallRecord(scope.row.callId)"
              size="mini"
            >
              查看录音
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer">
        <el-button type="primary" @click="saveAlert">提交新催办</el-button>
        <el-button @click="sendAlert">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="通话录音"
      :visible.sync="callRecording"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      custom-class="c-dialog"
      @close="callRecordingData = {}"
    >
      <div class="box-center-content" style="border: 1px solid #ccc; border-radius: 6px">
        <div class="activity-card">
          <div class="activity-card-header">
            <span class="c-font-500">
              <i class="el-icon-phone-outline c-w-30"></i>
              <span v-if="callRecordingData.callDirection == '0'">呼入</span>
              <span v-else-if="callRecordingData.callDirection == '1'">呼出</span>
            </span>
            <span>{{ osg.codelabel('callResult', callRecordingData.callResult) }}</span>
          </div>
          <div class="activity-card-content">
            <div>
              主叫：{{ callRecordingData.callerName }}
              {{ callRecordingData.caller }}
            </div>
            <div>
              被叫：{{
                callRecordingData.callWay == 4
                  ? callRecordingData.calleeName || ''
                  : callRecordingData.callDirection == '0'
                  ? callRecordingData.calleeName || ''
                  : callRecordingData.calleeName || formData.name || ''
              }}{{ ' ' + callRecordingData.callee }}
            </div>
            <div>
              通话时间：{{ callRecordingData.startTimeStr }} 至
              {{ callRecordingData.endTimeStr }}
            </div>
            <audio
              v-if="callRecordingData.recordUrl"
              class="c-m-t-15 w-1"
              controls
              :src="callRecordingData.recordUrl"
            >
              您的浏览器不支持 audio 标签。
            </audio>
          </div>
          <div class="activity-card-footer">
            <!-- <span>操作人：{{ item.createUserName }}</span> -->
            <span></span>
            <span>生成记录时间：{{ callRecordingData.createTime }}</span>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="callRecording = false">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// import areajs from '../../resources/js/area.js';
export default {
  activated() {
    window.$this = this;
  },
  name: 'projects',
  props: {
    serviceState: {
      type: String
    },
    //通话记录id
    callId: {
      type: String
    }
  },
  data() {
    return {
      tenantId: '',
      refresh: true,
      name: 'project',
      state: '', //已归档 archive
      orderState: '', //全部 待办 已办
      multipleSelection: [], //多选
      fpi: {},
      searchValue: '',
      openDetail: false,
      callRecording: false, //通话录音弹窗
      formData: {
        // priority: 1,
        exts: {},
        gpsPoint: {}
      },
      extFields: [],
      extFieldsData: [], //动态列表用到
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      options: {
        codecfg_stage: { codeId: 'STAGE' },
        codecfg_status: { codeId: 'STATUS' },
        codecfg_altertState: { codeId: 'altertState' },
        codecfg_callResult: { codeId: 'callResult' },
        //服务资源
        codecfg_resourceType: {
          codeId: 'resourceType'
        },
        codecfg_resourceRoles: {
          codeId: 'resourceRoles'
        },
        codecfg_workflowAlert: {
          codeId: 'workflowAlert'
        },
        subdistricts: []
      },
      rules: this.$util.rules,
      //地址级联-懒加载
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      },
      //当前行工作流节点
      currentWorkflow: {},
      //分单（分服务资源）
      SR: {
        show: false,
        fpi: {},
        selectRow: {},
        selectId: '',
        searchValue: '',
        ids: [], //选择服务区域筛选出的关联的服务资源id
        resourceType: [], //筛选服务资源类型
        resourceRoles: [], //筛选资源角色
        nodeType: '', //当前节点类型
        loading: false //表格数据加载
      },
      //派单（分服务资源）
      user: {
        show: false,
        fpi: {},
        selectRow: {},
        selectId: ''
      },
      acountIds: [], //当前用户id 组织id 角色id
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      workflowAlert: false,
      workflowAlertData: {
        handlerIds: []
      },
      workflowAlerFpi: {},
      alertUser: {},
      alertTableData: [],
      callRecordingData: {}, //通话记录
      /**
       * 中间号
       */
      privateNumber: {
        show: false,
        phone: ''
      }
    };
  },
  beforeCreate() {
    window.$this = this;
  },
  mounted() {
    //当前用户id 组织id 角色id
    let acount = JSON.parse(sessionStorage['loginAccount']);
    this.acountIds = acount.roleIds.concat(acount.orgIds);
    this.acountIds.push(acount._id);
    this.tenantId = acount.tenantId;
    this.osg.getFpi();
    this.doInit();
  },
  methods: {
    formatSRType(row, column, cellValue) {
      return this.osg.codelabel('resourceType', cellValue);
    },
    formatST(row, column, cellValue) {
      return this.osg.codelabelInArray('ST', cellValue);
    },
    formatOrg(cellValue) {
      return this.osg.codelabel('org', cellValue);
    },
    formatUser(cellValue) {
      return this.osg.codelabel('users', cellValue);
    },
    doInit() {
      this.openDetail = false;
      this.formData = {
        exts: {},
        gpsPoint: {}
      };

      this.privateNumber = {
        show: false,
        phone: ''
      };
      if (this.$refs.formData) this.$refs.formData.resetFields();
      this.$util.renderExtField(this.extFields, this.formData);
      this.orderState = this.osg.param('orderState');

      this.osg.getFields('project', () => {
        if (this.serviceState) {
          if (this.$route.params.searchValue) {
            this.searchValue = this.$route.params.searchValue;
          }
          this.getData();
        } else {
          this.getData();
        }
      });
    },
    //查询客户
    querySearch(queryString, cb) {
      var params = {
        page: 1,
        rows: 10,
        sortField: 'createTime',
        sortOrder: 'desc',
        'regex:name|string#or': queryString,
        'regex:phone|string#or': queryString
      };
      this.osg.ajax(
        'basic/contacts/query.do',
        params,
        res => {
          cb(res.data);
        },
        { noload: true }
      );
    },
    //选择客户
    handleSelect(item) {
      let contactIds = this.formData.contactIds || [];
      contactIds.push(item._id);
      // this.$set(this.formData, 'contactIds', contactIds);
      this.$set(this.formData, 'phone', item.phone);
      this.$set(this.formData, 'area', item.area);
      this.$set(this.formData, 'address', item.address);
    },
    //根据项目客户姓名自动生成项目标题
    changeName(val) {
      // TODO:
      if (this.tenantId == '1340835581184723420') {
        this.$set(this.formData, 'title', val + '的项目' + this.$util.readableTime());
      } else if (this.tenantId == '4551453470943235290') {
        this.$set(this.formData, 'title', val + '的项目');
      }
    },
    pageSizeChange(pageSize) {
      if (this.SR.show) {
        this.SR.fpi.rows = pageSize;
        this.getSR();
      } else if (this.workflowAlert) {
        this.workflowAlerFpi.rows = pageSize;
        this.alertMsgList();
      } else {
        this.fpi.rows = pageSize;
        this.getData();
      }
    },
    pageChange(currentPage) {
      if (this.SR.show) {
        this.SR.fpi.page = currentPage;
        this.getSR();
      } else if (this.workflowAlert) {
        this.workflowAlerFpi.rows = currentPage;
        this.alertMsgList();
      } else {
        this.fpi.page = currentPage;
        this.getData();
      }
    },
    getData() {
      if (!this.orderState || this.orderState == 'archived') {
        this.getSA();
        return;
      }
      var params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 20,
        sortField: 'createTime',
        sortOrder: 'desc',
        orderState: this.orderState,
        'regex:title|string#or': this.searchValue,
        'regex:name|string#or': this.searchValue,
        'regex:phone|string#or': this.searchValue,
        'regex:orderNum|string#or': this.searchValue,
        'regex:address|string#or': this.searchValue
      };
      window.$that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('basic/project/querySAWorkflowNode.do', params, res => {
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
        });
      });
    },
    //查询项目列表（非工作流记录）
    getSA() {
      let params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 20,
        sortField: 'createTime',
        sortOrder: 'desc',
        'in:state|integer#and': this.orderState == 'archived' ? -1 : 1,
        'regex:name|string#or': this.searchValue,
        'regex:title|string#or': this.searchValue,
        'regex:phone|string#or': this.searchValue,
        'regex:orderNum|string#or': this.searchValue,
        'regex:address|string#or': this.searchValue
      };
      window.$that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('basic/project/query.do', params, res => {
        let data = [];
        res.data.map(item => {
          data.push({
            data: item
          });
        });
        res.data = data;
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
        });
        this.$forceUpdate();
      });
    },
    doEnable(id) {
      this.osg.ajax('basic/project/enable/' + id + '.do', null, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doDisable(id) {
      this.osg.ajax('basic/project/disable/' + id + '.do', null, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doRemove(row) {
      this.osg.confirm(`是否确认删除 ${row.name}？`, () => {
        this.osg.ajax('basic/project/remove.do', { id: row._id }, () => {
          this.getData();
          this.osg.toast('操作成功！');
        });
      });
    },
    doArchive(row, msg) {
      this.osg.confirm(`是否确认${msg}项目 ${row.title}？`, () => {
        this.osg.ajax('basic/project/archive/' + row._id + '.do', null, () => {
          this.getData();
          this.osg.toast(`已${msg}项目 ${row.title}`);
        });
      });
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    doEdit(row) {
      row = this.$util.deepCopy(row);
      row.gpsPoint = row.gpsPoint || {};
      this.$util.renderExtField(this.extFields, row);
      this.formData = row;
      this.formData.exts = this.formData.exts || {};
      // 无手机号返回查看中间号按钮
      if (!row.phone) {
        this.privateNumber.show = true;
      } else {
        this.privateNumber.show = false;
      }
      this.openDetail = true;
      this.osg.getSubdistricts(this.formData.area, result => {
        this.options.subdistricts = result;
        this.$forceUpdate();
      });
    },
    doSave() {
      if (this.osg.validate()) {
        if (this.osg.isRepeatClick('doSave', 5000)) {
          return;
        }
        let params = this.formData;
        params.area = params.area || [];
        if (params.area.length > 0) {
          params.province = params.area[0] || '';
          if (params.area.length > 1) {
            params.city = params.area[1] || '';
            if (params.area.length > 2) {
              params.district = params.area[2] || '';
              if (params.area.length > 3) {
                params.subdistrict = params.area[3] || '';
              }
            }
          }
        }
        delete params.gpsPoint;

        this.osg.ajax('basic/project/upsert.do', { data: JSON.stringify(params) }, () => {
          this.doInit();
          this.getData();
        });
      }
    },
    //项目数据模板
    converTemp(data, assignData) {
      var row = this.$util.deepCopy(data);
      let obj = {
        // contactIds: [row._id],
        name: row.name,
        address: row.address,
        area: row.area,
        // belongTo: row.belongTo,
        province: row.province,
        city: row.city,
        district: row.district,
        community: row.community,
        phone: row.phone,
        channel: row.channel,
        exts: {}
        // leadIds: [row._id]
      };
      return Object.assign(obj, assignData ? assignData : {});
    },
    //展示分配服务资源
    openSR(row, wf) {
      if (wf) {
        // 重新分派
        this.SR.nodeType = wf.nodeDef.nodeTypeOld || wf.nodeDef.nodeType;
        this.currentWorkflow = wf;
        this.formData = row;
      } else {
        this.SR.nodeType = row.nodeDef.nodeType;
        this.currentWorkflow = row;
        this.formData = row.data;
      }
      //赋值资源类型、资源角色 筛选框
      this.SR.resourceType =
        this.SR.resourceType.length > 0
          ? this.SR.resourceType
          : this.currentWorkflow.nodeDef.resourceType;
      this.SR.resourceRoles =
        this.SR.resourceRoles.length > 0
          ? this.SR.resourceRoles
          : this.currentWorkflow.nodeDef.resourceRoles;
      this.$forceUpdate();

      this.formData.gpsPoint = this.formData.gpsPoint || {};
      this.formData.exts = this.formData.exts || {};
      //获取服务区域 筛选
      this.getServiceTerritory();
      //获取服务资源
      this.getSR();
      this.SR.show = true;
      this.SR.loading = true;
    },
    //获取服务资源
    getSR() {
      let params = {
        page: this.SR.fpi.page || 1,
        rows: this.SR.fpi.rows || 20,
        'in:state|array-integer#and': '1',
        sortField: 'createTime',
        sortOrder: 'desc',
        'regex:name|string#and': this.SR.searchValue,
        'in:_id|array#and': this.SR.ids, //按服务区域关联的服务资源筛选
        'in:resourceType|array#and': this.SR.resourceType && this.SR.resourceType.join(),
        'in:resourceRoles|array#and': this.SR.resourceRoles && this.SR.resourceRoles.join()
      };
      this.osg.ajax(
        'biz/serviceResource/query.do',
        params,
        async res => {
          //收集服务资源id、组织id、用户id
          let SRIds = [];
          let orgIds = [];
          let userIds = [];
          res.data.map(item => {
            SRIds.push(item._id);
            if (item.resourceType == 'partner' || item.resourceType == 'serviceCrew') {
              //伙伴、班组
              orgIds.push(item.serviceCrewId);
            } else {
              //technician技师、dispatcher派单员
              userIds.push(item.relatedRecordId);
            }
          });

          //获取服务区域、组织、用户 用作返显服务区域和资源名称
          if (SRIds.length > 0) {
            await new Promise(resolve => {
              this.getST(SRIds, resolve);
            });
            if (orgIds.length > 0) {
              await new Promise(resolve => {
                this.getOrgs(orgIds, resolve);
              });
            }
            if (userIds.length > 0) {
              await new Promise(resolve => {
                this.getUsers(userIds, resolve);
              });
            }
          }
          this.SR.fpi = res;
          this.SR.loading = false;
        },
        {
          noload: true
        }
      );
    },
    selectSR(row) {
      if (row) {
        this.SR.selectRow = row;
        this.SR.selectId = row._id;
      }
    },
    saveSR() {
      if (!this.SR.selectId) {
        this.osg.toast('请选择服务资源！', 'warning');
        return;
      }
      let params = {
        smodule: 'project',
        workflowNodeId: this.currentWorkflow._id
      };
      if (
        this.SR.selectRow.resourceType == 'partner' ||
        this.SR.selectRow.resourceType == 'serviceCrew'
      ) {
        params.currentOrgId = this.SR.selectRow.serviceCrewId;
      } else {
        params.handlerId = this.SR.selectRow.relatedRecordId;
      }
      //撤回单
      let msg = this.orderState ? '' : '重新';
      this.osg.confirm(
        `是否确认${msg}${this.currentWorkflow.nodeDef.name}给 ${this.SR.selectRow.name}`,
        () => {
          this.cancelSR();
          if (!this.orderState) {
            //重新分派单
            this.takebackWorkflow(() => {
              this.process(params);
            });
          } else {
            //首次分派单
            this.process(params);
          }
        }
      );
    },
    // 撤回到当前节点
    takebackWorkflow(callback) {
      let params = {
        workflowNodeId: this.currentWorkflow._id,
        smodule: 'project',
        sid: this.formData._id
      };

      this.osg.ajax(
        'workflow/takebackWorkflow.do',
        params,
        () => {
          if (callback) callback();
        },
        { noload: true }
      );
    },
    // 分派
    process(params) {
      this.osg.ajax('workflow/process.do', params, () => {
        this.osg.toast(`${this.currentWorkflow.nodeDef.name}成功`);
        this.getData();
        this.doInit();
      });
    },
    cancelSR() {
      this.SR.show = false;
      this.SR.selectRow = {};
      this.SR.selectId = '';
      this.SR.searchValue = '';
      this.SR.resourceType = []; //筛选服务资源类型
      this.SR.resourceRoles = []; //筛选资源角色
    },
    //获取所有服务区域支持搜索
    getServiceTerritory(query) {
      this.osg.ajax(
        'basic/serviceTerritory/query.do',
        {
          _all: '1',
          'regex:name|string#and': query,
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = (item.relatedIds && item.relatedIds.join()) || ' ';
          });
          this.options.serviceTerritory = res.data;
          this.$forceUpdate();
        },
        {
          noload: true
        }
      );
    },
    //获取当前服务资源列表所属的服务区域 返显
    getST(SRIds, resolve) {
      this.osg.ajax(
        'basic/serviceTerritory/query.do',
        {
          // page: 1,
          // rows: SRIds.length,
          _all: '1',
          'in:relatedIds|array#and': SRIds.join(),
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item.relatedIds;
          });
          this.options.ST = res.data;
          resolve();
        },
        {
          noload: true
        }
      );
    },
    //获取组织
    getOrgs(orgIds, resolve) {
      this.osg.ajax(
        'org/query.do',
        {
          page: 1,
          rows: orgIds.length,
          'in:_id|array#and': orgIds.join()
        },
        res => {
          res.data.orgList.map(item => {
            item.label = item.orgName;
            item.value = item._id;
          });
          this.options.org = res.data.orgList;
          resolve();
        },
        {
          noload: true
        }
      );
    },
    // 服务资源列表返显用户名称
    getUsers(userIds, resolve) {
      this.osg.ajax(
        'user/query.do',
        {
          page: 1,
          rows: userIds.length,
          'in:_id|array#and': userIds && userIds.join()
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.options.users = res.data;
          resolve();
        },
        {
          noload: true
        }
      );
    },
    //表格刷新
    Refresh() {
      this.refresh = false;
      this.$nextTick(function() {
        this.refresh = true;
      });
    },
    //获取地理编码
    async getGeocode() {
      if (this.formData.area[0] && this.formData.area[1]) {
        var citys = await this.$util.getCity(this.formData.area[0]);
        var cityName = '';
        for (var city of citys) {
          if (city._id == this.formData.area[1]) {
            cityName = city.name;
            break;
          }
        }
        this.osg.geocode(cityName + this.formData.address, res => {
          this.formData.gpsPoint = {
            longitude: res.location.split(',')[0],
            latitude: res.location.split(',')[1]
          };
          this.$forceUpdate();
        });
      }
    },
    //判断是否展示重新分派下拉菜单
    btnShow(data) {
      var { workflowNodeList } = data;
      if (
        workflowNodeList[workflowNodeList.length - 1] &&
        workflowNodeList[workflowNodeList.length - 1].state == 10
      )
        return false;
      let createUser = data.createUser;
      for (var i = 1; i < workflowNodeList.length; i++) {
        if (this.available(workflowNodeList[i], createUser)) {
          return true;
        }
      }
      return false;
    },
    //用于扩展字段，判断如果配置了因为某个字段值才显示
    isShowField(obj, key, showField, showValue) {
      if (
        obj[showField] &&
        (obj[showField] == showValue || Array.isArray(obj[showField])
          ? obj[showField].flat().indexOf(showValue) !== -1
          : obj[showField].indexOf(showValue) !== -1)
      )
        return true;

      obj.exts = obj.exts || {};
      if (
        obj.exts[showField] &&
        (obj.exts[showField] == showValue || Array.isArray(obj.exts[showField])
          ? obj.exts[showField].flat().indexOf(showValue) !== -1
          : obj.exts[showField].indexOf(showValue) !== -1)
      )
        return true;
    },
    // 判断当前登录用户是否可操作重新分派
    available(workflowNode, createUser) {
      if (
        workflowNode.state == 10 &&
        (workflowNode.nodeDef.nodeTypeOld == 'allot' ||
          workflowNode.nodeDef.nodeType == 'allot' ||
          workflowNode.nodeDef.nodeTypeOld == 'dispatch' ||
          workflowNode.nodeDef.nodeType == 'dispatch')
      ) {
        var { userChooseRule, userChoose } = workflowNode.nodeDef;
        if (userChooseRule == 'starter') {
          // 发起人
          if (this.acountIds.indexOf(createUser) != -1) {
            return true;
          } else {
            return false;
          }
        } else {
          for (var id of userChoose) {
            if (this.acountIds.indexOf(id) != -1) {
              return true;
            }
          }
          return false;
        }
      } else {
        return false;
      }
    },
    //查看通话记录
    viewCallRecord(callId) {
      this.osg.ajax(
        'basic/sobot/queryByCallId.do',
        {
          callId
        },
        res => {
          this.callRecording = true;
          this.callRecordingData = res.data;
          //   if (res.data)
          //     this.callRecordingData = res.data;
          //     this.record.openCallRecord = true;
          //   }
        },
        { noload: true }
      );
    },
    /**
     * 外呼
     */
    callOut(_id) {
      // 调用外呼接口-传外呼号码
      // this.osg.sobot.callOut({
      //   destinationNumber: row.data.phone,
      //   params: `{ "bizType": "project","bizId":"${row.data._id}"}`
      // });
      this.$router.push({
        path: `/project/${_id}`,
        query: { isCall: true }
      });
    },
    /**
     * 数据导出(通过传表头数据方式实现),项目专用版
     */
    doExportSA(params) {
      let paramObj = {};
      let searchObj = {};
      //如有调整，项目导出使用的是单独个方法，需要去项目也进行修改!
      if (window.$that) {
        window.$that.getParams(params);
      }
      for (let paramKey in params) {
        //给查询条件 去掉fpi-
        if (paramKey.indexOf('|') != -1 || paramKey == 'sortField' || paramKey == 'sortOrder') {
          searchObj[paramKey.replace('fpi-', '')] = params[paramKey];
        } else {
          paramObj[paramKey] = params[paramKey];
        }
      }
      let headerList = []; //表头数据
      //   this.extFields.forEach(el => {
      //     if (el.showList && el.showList.includes('1')) {
      //       let obj = {};
      //       obj[el.nameDisp] = el.name;
      //       headerList.push(obj);
      //     }
      //     // let obj = {};
      //     //     obj[el.label] = el.prop && el.prop.replace('data.', '').replace('exts.', '');
      //     //     if (el.label || el.prop) headerList.push(obj);
      //   });
      this.$refs.table.$children.forEach(el => {
        let obj = {};
        obj[el.label] = el.prop && el.prop.replace('data.', '').replace('exts.', '');
        if (el.label || el.prop) headerList.push(obj);
      });
      if (!paramObj.beanName) paramObj.beanName = window.$this.name; //表格名
      if (!paramObj.title) paramObj.title = window.$this.name; //
      let jsonList = []; //生成文件名
      for (let pKey in paramObj) {
        let obj = {};
        obj[pKey] = paramObj[pKey];
        if (pKey) jsonList.push(obj);
      }
      jsonList = jsonList.concat(headerList);
      this.osg.ajax(
        'excel/export.do',
        Object.assign(searchObj, {
          jsonList: JSON.stringify(jsonList)
        }),
        res => {
          // 对文件名乱码转义--【Node.js】使用iconv-lite解决中文乱码
          let temp = res.headers['content-disposition'].split('=')[1];
          let iconv = require('iconv-lite');
          iconv.skipDecodeWarning = true; //忽略警告
          let fileName = iconv.decode(temp, 'gbk');
          const _res = res.data;
          let blob = new Blob([_res]);
          let downloadElement = document.createElement('a');
          let href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        },
        {
          responseType: 'blob'
        }
      );
    },
    //保存催办项目
    saveAlert() {
      var params = this.workflowAlertData;
      if (this.callId) params.callId = this.callId;

      this.osg.ajax('/biz/workflowAlert/upsert.do', params, () => {
        this.sendAlert();
        this.osg.toast('保存成功！');
        this.$emit('delCallId', true);
      });
    },
    //新增催办项目弹出页面
    readyAlert(row) {
      let creatorId = row.createUser;
      let workflowId = row.workflowId;
      let tenantId = row.tenantId;
      this.workflowAlertData.workflowId = workflowId;
      this.osg.ajax('/workflow/getTodoNodes.do', { tenantId, workflowId }, res => {
        this.workflowAlertData.workflowNodeId = res._id;
        if (res.userChooseRule && res.userChooseRule.startsWith('role')) {
          let roleIds = res.userChooseRule.replace('role:', '').split(',');
          let roleParam = {
            _all: '1',
            'in:roleIds|array#and': roleIds.join(','),
            'is:state|integer#and': 1
          };
          this.osg.ajax('user/query.do', roleParam, res => {
            this.alertUser = res.data;
            this.workflowAlertData.handlerIds = res.data.map(item => item._id);
            this.workflowAlert = true;
          });
        } else if (res.userChooseRule && res.userChooseRule.startsWith('orgrole')) {
          let roleIds = res.userChooseRule.replace('orgrole:', '').split(',');
          let orgIds = res.handlerIds.map(item => item.split('+')[0]);
          // let orgId = res.handlerIds[0].split('+')[0];
          let orgParams = {
            _all: '1',
            'in:orgIds|array#and': orgIds.join(','),
            'in:roleIds|array#and': roleIds.join(','),
            'is:state|integer#and': 1
          };
          this.osg.ajax('user/query.do', orgParams, res => {
            this.alertUser = res.data;
            this.workflowAlertData.handlerIds = res.data.map(item => item._id);
            this.workflowAlert = true;
          });
        } else if (res.userChooseRule && res.userChooseRule.startsWith('starter')) {
          let startParams = {
            'is:state|integer#and': 1,
            'is:_id|String#and': creatorId
          };
          this.osg.ajax(`user/find/${creatorId}.do`, startParams, res => {
            this.alertUser = res.data;
            this.workflowAlertData.handlerIds = [res.data._id];
            this.workflowAlert = true;
          });
        } else {
          let userIds = res.handlerIds;
          let userParams = {
            _all: '1',
            'in:_id|array#and': userIds,
            'is:state|integer#and': 1
          };
          this.osg.ajax('user/query.do', userParams, res => {
            this.alertUser = res.data;
            this.workflowAlertData.handlerIds = res.data.map(item => item._id);
            this.workflowAlert = true;
          });
        }
      });
      this.alertMsgList(row);
      this.workflowAlertData.type = 1;
    },
    //控制催办弹出页面
    sendAlert() {
      this.workflowAlert = false;
      //this.workflowAlertData = {};
    },
    alertMsgList(sa) {
      let param = {
        page: this.workflowAlerFpi.page || 1,
        rows: this.workflowAlerFpi.rows || 10,
        'is:workflowId|string#and': sa.workflowId
      };
      this.osg.ajax('biz/workflowAlert/query.do', param, res => {
        if (res.data) {
          this.alertTableData = res.data;
          let handles = res.data.map(item => item.handleUserId);
          this.osg.ajax(
            'user/query.do',
            {
              _all: '1',
              'in:_id|array#and': handles
            },
            res => {
              var names = {};
              res.data.forEach(item => {
                names[item._id] = item.name;
              });
              for (var i = 0; i < this.alertTableData.length; i++) {
                let uId = this.alertTableData[i].handleUserId;
                // if (names[uId]) {
                //   this.alertTableData[i].handleUserName = names[uId];
                // } else {
                //   this.alertTableData[i].handleUserName = '';
                // }
                names[uId] ? (this.alertTableData[i].handleUserName = names[uId]) : '';
              }
              this.$forceUpdate();
            }
          );
        }
      });
    },
    formatType1Type(row, column, cellValue) {
      if (cellValue || cellValue === 0) {
        return this.osg.codelabel('workflowAlert', cellValue);
      }
    },
    formatAltertState(row, column, cellValue) {
      if (cellValue || cellValue === 0) {
        return this.osg.codelabel('altertState', cellValue);
      }
    }
  },
  watch: {
    $route() {
      // window.$this = this;
      // this.osg.getFpi();
      // this.doInit();
      if (this.serviceState) {
        if (this.$route.params.searchValue) {
          this.searchValue = this.$route.params.searchValue;
        }
      }
      // this.getData();
      this.Refresh();
    },
    //area 级联组件点击label就消失
    'formData.area'() {
      if (this.$refs.areaSelector) {
        this.$refs.areaSelector.dropDownVisible = false; //监听值发生变化就关闭它
      }
    }
  }
};
</script>
<style>
.projects .c-dialog {
  min-width: 1000px !important;
}
</style>
